/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import { stringKeyToTuple } from 'js/lib/stringKeyTuple';

import { CMLUtils } from 'bundles/cml';
import { editReply, hideReplyEditor } from 'bundles/discussions/actions/DropdownActions';
import ForumsCmlEditor from 'bundles/discussions/components/ForumsCmlEditor';
import { DTD_NAME } from 'bundles/discussions/constants';
import DiscussionsCMLUtils, { getErrorMessageFromCode } from 'bundles/discussions/utils/DiscussionsCMLUtils';
import type { NaptimeError } from 'bundles/naptimejs';

import _t from 'i18n!nls/discussions';

import 'css!bundles/discussions/components/NewThreadForm/__styles__/NewThreadForm';

class ReplyCMLEdit extends React.Component {
  static propTypes = {
    reply: PropTypes.object.isRequired,
    courseId: PropTypes.string,
    onSubmitSuccess: PropTypes.func,
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
  };

  declare context: LegacyContextType<typeof ReplyCMLEdit.contextTypes>;

  constructor(props: $TSFixMe, context: $TSFixMe) {
    super(props, context);
    const modelContent = props.reply.content;
    let cml = modelContent;

    // convert non-cml post into cml
    // can be removed if all posts are cml
    if (!modelContent || !modelContent.typeName) {
      const value = '<co-content><text>' + (modelContent || '') + '</text></co-content>';
      cml = CMLUtils.create(value, DTD_NAME);
    }

    // Use the new dtdId. Can be removed once all posts have the current dtdId
    cml.definition.dtdId = DTD_NAME;

    this.state = {
      initialValue: cml.definition.value,
      cml,
      hasErrors: false,
      submitError: false,
      submitEnabled: false,
    };

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'editorElemRef' does not exist on type 'R... Remove this comment to see the full error message
    this.editorElemRef = null;
  }

  focusOnEditor = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'editorElemRef' does not exist on type 'R... Remove this comment to see the full error message
    this?.editorElemRef?.focus?.();
  };

  componentDidMount() {
    this.focusOnEditor();
  }

  handleSubmit = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'hasErrors' does not exist on type 'Reado... Remove this comment to see the full error message
    if (this.state.hasErrors) {
      this.focusOnEditor();
      return;
    }

    this.setState({
      submitEnabled: false,
    });

    this.context.executeAction(editReply, {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'reply' does not exist on type 'Readonly<... Remove this comment to see the full error message
      reply: this.props.reply,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'cml' does not exist on type 'Readonly<{}... Remove this comment to see the full error message
      content: this.state.cml,
      handleFailure: this.onSubmitError,
      onSuccess: this.onSubmitSuccess,
    });
  };

  handleCancel = () => {
    this.hideEdit();
  };

  handleInputChange = (cml: $TSFixMe) => {
    this.setState({
      cml,
      hasErrors: !DiscussionsCMLUtils.validateLength(cml),
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'initialValue' does not exist on type 'Re... Remove this comment to see the full error message
      submitEnabled: cml.definition.value !== this.state.initialValue,
    });
  };

  onSubmitError = (e: NaptimeError) => {
    this.setState({
      submitError: true,
      submitEnabled: true,
      saveErrorMessage: getErrorMessageFromCode(e?.responseJSON?.errorCode),
    });
  };

  onSubmitSuccess = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'onSubmitSuccess' does not exist on type 'Readonly<... Remove this comment to see the full error message
    this.props.onSubmitSuccess?.();
  };

  hideEdit() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'reply' does not exist on type 'Readonly<... Remove this comment to see the full error message
    this.context.executeAction(hideReplyEditor, { reply: this.props.reply });
  }

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'cml' does not exist on type 'Readonly<{}... Remove this comment to see the full error message
    const contentLengthWarning = DiscussionsCMLUtils.generateContentLengthWarning(this.state.cml);

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'reply' does not exist on type 'Readonly<... Remove this comment to see the full error message
    const questionIdParts = stringKeyToTuple(this.props.reply.questionId || '');
    const questionId = questionIdParts[questionIdParts.length - 1];
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'courseId' does not exist on type 'Readon... Remove this comment to see the full error message
    const imageUploadOptions = DiscussionsCMLUtils.getImageUploadOptions(this.props.courseId, questionId);

    return (
      <div className="rc-ReplyCML" data-rc="ReplyCML">
        <div className="editor-container">
          <ForumsCmlEditor
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'cml' does not exist on type 'Readonly<{}... Remove this comment to see the full error message
            cml={this.state.cml}
            placeholder={_t('Reply')}
            imageUploadOptions={imageUploadOptions}
            ariaLabel={_t('Edit Reply')}
            onChange={this.handleInputChange}
          />
        </div>
        <div className="horizontal-box align-items-right">
          <div className="flex-2">
            {contentLengthWarning}
            {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'submitError' does not exist on type 'Rea... Remove this comment to see the full error message */}
            {this.state.submitError && (
              /* @ts-expect-error ts-migrate(2339) FIXME: Property 'errorMessage' does not exist on type 'Rea... Remove this comment to see the full error message */
              <div className="c-error-text c-form-error-message">{this.state.saveErrorMessage}</div>
            )}
          </div>
          <button
            type="button"
            className="passive cancel"
            onClick={this.handleCancel}
            css={css`
              &:hover,
              &:focus {
                background-color: #767676 !important;
                border-color: #767676 !important;
              }
            `}
          >
            {_t('Cancel')}
          </button>
          <button
            type="button"
            ref="submit"
            className="secondary"
            onClick={this.handleSubmit}
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'submitEnabled' does not exist on type 'R... Remove this comment to see the full error message
            disabled={!this.state.submitEnabled || this.state.hasErrors}
          >
            {_t('Save')}
          </button>
        </div>
      </div>
    );
  }
}

export default connectToStores(['CourseStore'], ({ CourseStore }) => {
  return {
    courseId: CourseStore.getCourseId(),
  };
})(ReplyCMLEdit);
